export const environment = {
  production: false,
  environmentTitle: 'QA',
  googleMapsApiKey: 'AIzaSyCgi3mJLzBSF6igfCYC2-Y3DgaMEILBKAM',
  azureClientId: 'aa2c6e7c-51f8-4cf5-b217-cfea4767ef19',
  azureApiScope: 'https://dukeenergy.onmicrosoft.com/aa2c6e7c-51f8-4cf5-b217-cfea4767ef19/mattracker.read.write.api',
  azureTenantId: '2ede383a-7e1f-4357-a846-85886b2c0c4d',
  apiBaseUrl: 'https://mattracker-api-qa.duke-energy.app',
  reports: {
    damagedMats: 'https://app.powerbi.com/rdlEmbed?reportId=f84f99fa-3622-4ccd-b5c3-f11383ca152a&autoAuth=true&ctid=2ede383a-7e1f-4357-a846-85886b2c0c4d&experience=power-bi',
    cancelledRequests: 'https://app.powerbi.com/rdlEmbed?reportId=8a21d944-9b43-4054-9a80-c1c016877931&autoAuth=true&ctid=2ede383a-7e1f-4357-a846-85886b2c0c4d&experience=power-bi',
    rentalMats: 'https://app.powerbi.com/rdlEmbed?reportId=4e8c47ae-51d5-47d5-a375-89d38c0bdb8b&autoAuth=true&ctid=2ede383a-7e1f-4357-a846-85886b2c0c4d&experience=power-bi'
  },
  help: {
    adminName: 'Brandon Barr',
    adminEmail: 'Brandon.Barr@duke-energy.com',
    serviceNowLink: 'https://dukeenergy.servicenowservices.com/de?id=sc_cat_item&sys_id=4eac59cd878c89103a6e7406cebb3523'
  }
};
